import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home';
import { FormioTestComponent } from './formio-test';
import { LoginComponent } from './login';
import { AuthGuard, OnboardingGuard, ForceOnboardingGuard } from './_helpers';

import { IntroComponent } from './courses/sections/intro/intro.component';
import { TopicComponent } from './courses/sections/topic/topic.component';
import { CourseComponent } from './courses/course.component';
import { SectionComponent } from './courses/sections/section.component';
import { MeditationComponent } from './courses/meditation/meditation.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EditProfileComponent } from './dashboard/profile/edit-profile.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { ProfileComponent } from './dashboard/profile/profile.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';

const routes: Routes = [
    { path: '', component: DashboardComponent, canActivate: [AuthGuard, ForceOnboardingGuard] },
    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard, ForceOnboardingGuard] },
    { path: 'dashboard/:module', component: DashboardComponent, canActivate: [AuthGuard, ForceOnboardingGuard], pathMatch: 'full' },
    { path: 'dashboard/:module/participant/:participant', component: DashboardComponent, canActivate: [AuthGuard, ForceOnboardingGuard], pathMatch: 'full' },
    { path: 'dashboard/:module/:edit', component: DashboardComponent, canActivate: [AuthGuard, ForceOnboardingGuard] },
    { path: 'meditation/:id', component: MeditationComponent, canActivate: [AuthGuard, ForceOnboardingGuard]},
    { path: 'course-section/:id', component: SectionComponent, canActivate: [AuthGuard, ForceOnboardingGuard]},
    { path: 'course-intro/:id', component: IntroComponent, canActivate: [AuthGuard, ForceOnboardingGuard]},
    { path: 'course-topic/:id', component: TopicComponent, canActivate: [AuthGuard, ForceOnboardingGuard]},
    { path: 'course/:id', component: CourseComponent, canActivate: [AuthGuard, ForceOnboardingGuard]},
    { path: 'onboarding', component: OnboardingComponent, canActivate: [AuthGuard, OnboardingGuard] },
    { path: 'login', component: LoginComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'welcome/:token', component: WelcomeComponent, pathMatch: 'full' },
    { path: 'password-reset/:token', component: PasswordResetComponent, pathMatch: 'full' },

    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        onSameUrlNavigation:'reload',
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        scrollOffset: [0, 0] // [x, y]
      })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
